/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typing Speed Test`)
};

const es_typing_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test de Velocidad de Mecanografía`)
};

const de_typing_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipptest`)
};

const nl_typing_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typsnelheidstest`)
};

const fr_typing_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test de vitesse de frappe`)
};

const it_typing_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test di velocità di digitazione`)
};

const pt_br2_typing_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste de Velocidade de Digitação`)
};

const pt_typing_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste de Velocidade de Escrita`)
};

const ja_typing_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイピングスピードテスト`)
};

const zh_typing_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打字速度测试`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_tool_name", locale)
	if (locale === "en") return en_typing_tool_name(inputs)
	if (locale === "es") return es_typing_tool_name(inputs)
	if (locale === "de") return de_typing_tool_name(inputs)
	if (locale === "nl") return nl_typing_tool_name(inputs)
	if (locale === "fr") return fr_typing_tool_name(inputs)
	if (locale === "it") return it_typing_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_typing_tool_name(inputs)
	if (locale === "pt") return pt_typing_tool_name(inputs)
	if (locale === "ja") return ja_typing_tool_name(inputs)
	return zh_typing_tool_name(inputs)
};